import { Link } from 'react-router-dom';

const BookBanner = () => {
  return (
    <div data-testid="book-banner" className="overflow-hidden" style={{ background: '#0A0A0A', borderTop: '1px solid rgba(201,168,76,0.12)', borderBottom: '1px solid rgba(201,168,76,0.12)' }}>
      <div className="flex items-center animate-marquee whitespace-nowrap py-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <Link key={i} to="/book" className="flex items-center gap-6 mx-6" data-testid={`book-banner-link-${i}`}>
            <span className="text-[11px] tracking-[0.18em] uppercase" style={{ fontFamily: "'DM Mono', monospace", color: '#C9A84C' }}>
              SHE BUILT THIS — THE BOOK
            </span>
            <span className="text-[11px] tracking-[0.15em]" style={{ fontFamily: "'DM Mono', monospace", color: 'rgba(250,248,244,0.3)' }}>
              EDITION 1 NOW &middot; EDITION 2 APRIL 27
            </span>
            <span className="w-1 h-1 bg-[#C9A84C] inline-block" />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BookBanner;
